




































































import {Component, Prop, Vue} from "vue-property-decorator";
import BillingInfoInput from "@/components/billing_info/Input.vue";
import BillingInfoDisplay from "@/components/billing_info/Display.vue";
import BillingInfoConfirm from "@/components/billing_info/Confirm.vue";
import BillingInfoResult from "@/components/billing_info/Result.vue";

import {mapGetters} from "vuex";
import InvoiceInfo from "@/consoleapi/api/invoice_info";

@Component({
    components: {
        BillingInfoDisplay,
        BillingInfoInput,
        BillingInfoConfirm,
        BillingInfoResult
    },
    computed:
        mapGetters({
            progress:'billingInfo/progress'
        }),
})
export default class Info extends Vue {
    private inputName = '';
    private inputKana = '';
    private inputEmail = '';
    private inputEmailCc1 = '';
    private inputEmailCc2 = '';
    private inputEmailCc3 = '';
    // private inputPostCode = '';
    private inputPostCodeFirst = '';
    private inputPostCodeLatter = '';
    private inputCompanyName = '';
    private inputAddress = '';
    private inputBuildingName = '';
    private inputDepartmentName = '';

    private progress: string | null | undefined;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    public getName(inputName: string) {
        this.inputName = inputName;
    }

    public getKana(inputKana: string) {
        this.inputKana = inputKana;
    }

    public getEmail(inputEmail: string) {
        this.inputEmail = inputEmail;
    }

    public getEmailCc1(inputEmailCc1: string) {
        this.inputEmailCc1 = inputEmailCc1;
    }

    public getEmailCc2(inputEmailCc2: string) {
        this.inputEmailCc2 = inputEmailCc2;
    }

    public getEmailCc3(inputEmailCc3: string) {
        this.inputEmailCc3 = inputEmailCc3;
    }

    // public getPostCode(inputPostCode: string) {
    //     this.inputPostCode = inputPostCode;
    // }

    public getPostCodeFirst(inputPostCodeFirst: string) {
        this.inputPostCodeFirst = inputPostCodeFirst;
    }

    public getPostCodeLatter(inputPostCodeLatter: string) {
        this.inputPostCodeLatter = inputPostCodeLatter;
    }

    public getAddress(inputAddress: string) {
        this.inputAddress = inputAddress;
    }

    public getBuildingName(inputBuildingName: string) {
        this.inputBuildingName = inputBuildingName;
    }

    public getDepartmentName(inputDepartmentName: string) {
        this.inputDepartmentName = inputDepartmentName;
    }

    public getCompanyName(companyName: string) {
        this.inputCompanyName = companyName;
    }

    mounted() {
        this.$store.dispatch('billingInfo/pushProgress', 'display');
        const invoiceInfo = new InvoiceInfo();
        invoiceInfo.setBearerToken(this.bearerToken);
        invoiceInfo.get(this.accountId).then(response => {
            const info = response.data;
            this.inputEmail = info.billing_email_address;
            this.inputEmailCc1 = info.billing_email_address_cc_1;
            this.inputEmailCc2 = info.billing_email_address_cc_2;
            this.inputEmailCc3 = info.billing_email_address_cc_3;
            this.inputName = info.billing_name;
            this.inputKana = info.billing_name_kana;
            // this.inputPostCode = info.billing_postcode;
            this.inputPostCodeFirst = info.billing_postcode.substring(0,3);
            this.inputPostCodeLatter = info.billing_postcode.substring(3,7);
            this.inputAddress = info.billing_address;
            this.inputBuildingName = info.billing_building_name;
            this.inputDepartmentName = info.billing_department_name;
            this.inputCompanyName = info.billing_company;
        }).catch(error => {
            if(error.response.status === 404) {
                this.$store.dispatch('billingInfo/pushProgress', 'input');
            }
            //console.log(error.response);
        });
    }

    beforeDestroy() {
        this.$store.dispatch('users/pushProgress', 'display');
    }
}
